import React from 'react';
import PropTypes from 'prop-types';

import './VideoSection.scss';

import { getVideoType } from '../../../../utilities/ui_utilities';
import VideoPlayer from '../../../CompanyPages/Sections/VideoPlayer/VideoPlayer';
import CardTitle from '../../../Elements/CardTitle/CardTitle';

const responsiveVideoProps = {
    width: 850,
    height: 478,
    emitMetric: true,
};

export default class VideoSection extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        videoSrc: PropTypes.string.isRequired,
        heading: PropTypes.string,
    };

    static defaultProps = {
        heading: 'Build Your Pipeline of Qualified Female Talent',
    };

    render() {
        const videoType = getVideoType(this.props.videoSrc);

        if (!videoType) {
            return null;
        }

        return (
            <div className="component-Employer-Marketing-VideoSection">
                <CardTitle className="video-heading">
                    {this.props.heading}
                </CardTitle>
                <VideoPlayer
                    responsiveVideoProps={responsiveVideoProps}
                    videoSrc={this.props.videoSrc}
                    videoType={videoType}
                />
            </div>
        );
    }
}
